import easy_return_img from '../img/heroSuggest/Fuji_Dash_Returns_1x._SY304_CB432774714_.jpg';

export const easyReturn = {
    title: 'Easy returns',
    img: easy_return_img
}